import { atom } from 'jotai'

export const drawerAtom = atom(false)

export const isPageLoaderOpenAtom = atom(false)
